import { Button, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/reservations";
import WushCard from "../../layout/WushCard";
import { addDays, format } from "date-fns";
import WushTextField from "../../form/WushTextField";
import PageLoading from "../../layout/PageLoading";
import ReservationCard from "./ReservationCard";
import { useNavigate, useSearchParams } from "react-router-dom";
import useReservationStore from "../../../stores/useReservationStore";

export default function UpcomingPickups() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const defaultStartAt = searchParams.get('startAt') ? addDays(new Date(searchParams.get('startAt')), 1) : new Date();
  const defaultEndAt = searchParams.get('endAt') ? addDays(new Date(searchParams.get('endAt')), 1) : addDays(defaultStartAt, 7);

  const [startAt, setStartAt] = useState(format(defaultStartAt, 'yyyy-MM-dd'));
  const [endAt, setEndAt] = useState(format(defaultEndAt, 'yyyy-MM-dd'));

  const { reservations, setReservations } = useReservationStore();

  const [reservationsLoading, setReservationsLoading] = useState(true);

  useEffect(() => {
    setReservationsLoading(true);
    index({
      status: ['confirmed', 'paid'],
      fulfillmentStatus: ['fulfilled'],
      returnStatus: ['unreturned'],
      returnType: ['pickup'],
      sortBy: 'start_at',
      endAtStart: startAt,
      endAtEnd: endAt,
    }, (response) => {
      setReservations(response);
      setReservationsLoading(false);
    });
  }, [startAt, endAt]);

  return (
    <Stack>
      <Stack direction="row" mb={1}>
        <Button onClick={() => navigate(`/?startAt=${startAt}&endAt=${endAt}`)}>Back</Button>
      </Stack>
      <WushCard>
        <Stack p={2}>
          <Stack mb={1}>
            <Typography variant="h5" fontWeight="bold">Upcoming Pickups ({reservations?.length})</Typography>
          </Stack>
          <Stack direction="row" mb={3} spacing={2}>
            <WushTextField type="date" label="Start Date" value={startAt} onChange={(e) => setStartAt(e.target.value)} />
            <WushTextField type="date" label="End Date" value={endAt} onChange={(e) => setEndAt(e.target.value)} />
          </Stack>
          {reservationsLoading ?
            <PageLoading />
          : <Stack spacing={1}>
            {reservations?.map((reservation) => (
              <ReservationCard key={reservation.id} reservation={reservation} hideStartTime />
            ))}
          </Stack>}
        </Stack>
      </WushCard>
    </Stack>
  );
}